import React from 'react';
import { formatCurrency, formatPercent } from 'utils';
import { TooltipBase } from './';

export const TooltipTotalOngoingCharges = ({ payload }: any) => {
  const data = payload[0] && payload[0].payload;
  if (!data) return null;

  return (
    <TooltipBase>
      <p>Policy type: {data.name}</p>
      <p>Cash value: {formatCurrency(data.cash_value)}</p>
      <p>Percentage value: {formatPercent(data.percentage_value)}</p>
    </TooltipBase>
  );
};
